import { styled } from "@mui/material";

export const Title = styled("h3")(
  ({ theme, width = "100%", fontSize = "24px" }) =>
    (props) => ({
      fontSize: fontSize,
      textAlign: "left",
      width: width,
      margin: "0px",
      [theme.breakpoints.down("md")]: {
        fontSize: "22px",
      },
    })
);

export const GrayText = styled("h5")(({ theme }) => (props) => ({
  fontSize: "14px",
  color: "#828282",
  margin: "0px",
}));

export const DarkText = styled("h3")(({ them }) => (props) => ({
  fontSize: "14px",
  fontWeight: 400,
  color: "#333333",
  margin: "0px",
}));
